import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { editOrder } from '../../../../../crud/orders.crud';
import { IEditOrder, IOrderResponse } from '../../../../../interfaces/order';
import AlertDialog from '../../../../../components/other/Dialog/AlertDialog';

export const useEditOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const fm = useFormatMessage();
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState<{
    error: string;
    id: number;
    order: IEditOrder;
  } | null>(null);
  const [loadingEdit, setLoading] = useState(false);
  const [successEdit, setSuccess] = useState(false);
  const [editedOrder, setOrder] = useState<IOrderResponse>();
  const editOrderTaxi = async (id: number, order: IEditOrder) => {
    setLoading(true);
    editOrder(id, order)
      .then(res => {
        setSuccess(true);
        setOrder(res.data.data);
      })
      .catch(e => {
        if (e?.response?.data?.status === 409) {
          setAlertData({
            error: getResponseMessage(e),
            id,
            order,
          });
          setAlertOpen(true);
        } else {
          enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
          setOrder(undefined);
        }, 100);
      });
  };

  const AlertErrorComponent = () => (
    <AlertDialog
      open={isAlertOpen}
      message={alertData?.error || ''}
      okText='Подтверждаю изменение'
      cancelText='Закрыть без изменений'
      handleClose={() => {
        setAlertOpen(false);
        setAlertData(null);
      }}
      handleAgree={() => {
        if (alertData) {
          editOrderTaxi(alertData.id, { ...alertData.order, changeDriver: true });
          setAlertOpen(false);
          setAlertData(null);
        }
      }}
    />
  );

  return { editOrderTaxi, successEdit, loadingEdit, editedOrder, AlertErrorComponent };
};
